const isSuccess = status => status.toString().substring(0, 2) === "20";

export default { isSuccess };
